<template>
	<div>
		<textarea style="position: absolute;top: 0;left: 0;opacity: 0;z-index: -10;" ref="textareas" v-model="text" name="" id="" cols="30" rows="10"></textarea>
	</div>
</template>
<script>
export default {
    name: "copy",
    props: {
		text:{
			type:String,
			default:''
		}
	},
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
	watch:{
		text(){
		    let that = this;
		    that.$nextTick(()=> {
		        that.$refs.textareas.select(); // 选中文本
		        document.execCommand("copy"); // 执行浏览器复制命令
				that.$utils.alertText('复制成功');
		    }) 
		},
	},
    methods: {
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/copy.vue